import { useEffect } from 'react';

/**
 * Listens to all clicks on the links in a given element and its children
 * and calls the provided onClick handler.
 */
export const useDeepLinkClickListener = (elRef, onClick) => {
  useEffect(() => {
    const divElement = elRef.current;
    if (divElement) {
      const links = divElement.getElementsByTagName('a');

      const handleLinkClick = (event) => {
        onClick(event);
      };

      Array.from(links).forEach((link: HTMLLinkElement) => {
        link.addEventListener('click', handleLinkClick);
      });

      return () => {
        Array.from(links).forEach((link: HTMLLinkElement) => {
          link.removeEventListener('click', handleLinkClick);
        });
      };
    }
  }, [elRef, onClick]);
};
